var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1646_2507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9426 30.0704L21 39.0188L12.0574 30.0704C5.35039 30.3636 0 35.8586 0 42.6242V43.5256C0 46.0125 2.0186 48.0324 4.50388 48.0324H37.507C39.9922 48.0324 42.0109 46.0125 42.0109 43.5256V42.6242C42 35.8586 36.6496 30.3636 29.9426 30.0704ZM1.26977 7.48214L1.86667 7.62331V13.0966C1.2155 13.4876 0.737984 14.1717 0.737984 14.9971C0.737984 15.7898 1.17209 16.4414 1.77985 16.8432L0.325581 22.6966C0.162791 23.3482 0.52093 24.0106 1.04186 24.0106H4.95969C5.48062 24.0106 5.82791 23.3482 5.67597 22.6966L4.21085 16.8541C4.8186 16.4523 5.25271 15.7898 5.25271 15.0079C5.25271 14.1826 4.78605 13.4984 4.12403 13.1075V8.17716L10.3101 9.66494C9.50698 11.283 8.9969 13.0749 8.9969 15.0079C8.9969 21.6432 14.369 27.0188 21 27.0188C27.631 27.0188 33.0031 21.6432 33.0031 15.0079C33.0031 13.0749 32.5039 11.2722 31.6899 9.66494L40.7194 7.493C42.4233 7.08033 42.4233 4.95182 40.7194 4.53915L22.8667 0.21698C21.6512 -0.0762328 20.3597 -0.0762328 19.1442 0.21698L1.26977 4.51743C-0.423256 4.9301 -0.423256 7.06947 1.26977 7.48214Z",
    fill: "#512C9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1646_2507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/StudentIcon.8a1b77d32dd4f52f3a0ccb11e83d53b7.svg";
export { ForwardRef as ReactComponent };